// @ts-nocheck
import styled from "styled-components";
import Colors from "../../assets/colors/Colors";

const RowDiv = styled.div`
    display: flex;
    flex-direction: row;
`;

const ColumnDiv = styled.div`
    display: flex;
    flex-direction: column;
`;

const RowDivF1 = styled.div`
    display: flex;
    flex-direction: row;
    flex: 1 1 auto;
`;

const ColumnDivF1 = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;

interface FlexDivProps {
    flexValue: number
}

const FlexedDiv = styled<FlexDivProps, 'div'>('div')`
    flex: ${props => props.flexValue};
`;

const BackCaret = styled.div`
    margin-left: 5px;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 12px solid ${(props: {backColor: string}) => (props.backColor)};
    height: 0px;
`;

const RankingsNavbarDiv = styled.div`
    color: white;
    display: flex;
    flex-direction: row;
    text-align: center;
`;

const RankingsTitleDiv = styled.div`
    font-size: 20px;
    font-family: DMSans-Light;
    white-space:nowrap;
    overflow:hidden;
    align-self: center;
    margin-bottom: 0;
    color: ${(props: {isLife: boolean}) => (props.isLife ? Colors.fontWhite: Colors.fontGray)};

    &.title {
      font-family: DMSans-Bold;
    }
`;

export {
    RowDiv,
    ColumnDiv,
    FlexedDiv,
    RowDivF1,
    ColumnDivF1,
    BackCaret,
    RankingsNavbarDiv,
    RankingsTitleDiv
};
